// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"fa67aa2cf1cfd11d3386","691":"0255ba8df3b895b8f460","731":"c762e8e154d5bd5fea2e","843":"7c5f2c71534ecc4906de"}[chunkId] + ".js";
};